import {format} from 'date-fns';
import {t} from '../../../common/getTranslations';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {Label} from '../../molecules/Label/Label';
import {LabelType} from '../../molecules/Label/LabelType.enum';
import {CommentTopAreaProps} from './CommentTopAreaProps.interface';

export function CommentTopArea({
  isBestComment,
  isBlockedByUser,
  nickname,
  registrationDate,
  onClickMore,
}: CommentTopAreaProps) {
  return isBlockedByUser ? (
    <div className="flex items-center">
      <Text className="font-small1-bold flex-1 break-all text-theme-solid-100 line-clamp-1">
        {nickname}
      </Text>
      <div
        className="flex h-28pxr w-28pxr cursor-pointer items-center justify-center rounded-8pxr bg-theme-solid-10"
        onClick={onClickMore}
      >
        <Icon type={IconType.ListMore} />
      </div>
    </div>
  ) : (
    <div className="flex items-center">
      {isBestComment && (
        <Label
          type={LabelType.Static06}
          text={t('comment_badge_best')}
          className="mr-6pxr"
        />
      )}
      <Text className="font-small1-bold mr-15pxr flex-1 break-all text-theme-solid-100 line-clamp-1">
        {nickname}
      </Text>
      {registrationDate && (
        <Text className="font-small2 shrink-0 text-theme-solid-60">
          {format(
            new Date(registrationDate),
            t('date_formatter_short_year_dot')
          )}
        </Text>
      )}
    </div>
  );
}
